import AsyncStorage from '@react-native-async-storage/async-storage';
import http from '../utils/http';

class SessionTokenService {

    validateToken () {
        return new Promise(async (resolve, reject) => {
            let userToken = await AsyncStorage.getItem('userToken');
            if (userToken) {
                const form = new FormData()
                form.append('token', userToken)
                http.post('user_session/validate', form)
                    .then(res => {
                        if (res.code === 200 && res.data.authenticated === true) {
                            resolve(res)
                        } else {
                            reject(new Error(res.message))
                        }
                    })
                    .catch(err => {
                        // reject(err)
                        resolve(null) // allow for retry maybe due to internet
                    })
            } else {
                reject(new Error('Not authenticated.'))
            }
        })
    }

}

export default SessionTokenService;